import type { Entity } from "../../../core/types/fe/Entity";
import { InlineFormFieldStyle } from "../../SearchForm/styles/SearchFormFieldsStyle";
import { isFieldVisible } from "../components/ConditionalWrapper/ConditionalWrapper";
import { FormFieldRender } from "../components/FormFieldRender";
import { createVerticalFormField } from "../formFieldLabelPositioning/Vertical/CreateVerticalFormField";
import type { FormLayoutProps } from "../types";
import type { FormField, FormTab } from "../types/types";

export const InlineFormLayout = <T extends Entity>(props: FormLayoutProps<T>) => {
    const { formDefinition, onChange, formData } = props;

    return (
        <InlineFormFieldStyle>
            {formDefinition.tabs.map((tab: FormTab) => {
                return tab.fields.map((field: FormField) => {
                    const hasVisibility = (currentField: FormField) => {
                        if (
                            isFieldVisible(formData, currentField?.attributes) &&
                            !field.component.startsWith("Hidden") &&
                            field.attributes?.visible !== false
                        ) {
                            return true;
                        }
                        return false;
                    };

                    const isVisible = hasVisibility(field);

                    return (
                        <FormFieldRender
                            key={`${field.name}FormField`}
                            field={field}
                            factory={createVerticalFormField}
                            readOnly={false}
                            isVisible={isVisible}
                            onChange={onChange}
                        />
                    );
                });
            })}
        </InlineFormFieldStyle>
    );
};
